/**
 * main.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2015, Codrops
 * http://www.codrops.com
 */
(function () {

	"use strict";
	if (!document.getElementById('theGrid')) {
		return;
	}	
	var bodyEl = document.body,
		docElem = window.document.documentElement,
		support = {
			transitions: Modernizr.csstransitions
		},
		// transition end event name
		transEndEventNames = {
			'WebkitTransition': 'webkitTransitionEnd',
			'MozTransition': 'transitionend',
			'OTransition': 'oTransitionEnd',
			'msTransition': 'MSTransitionEnd',
			'transition': 'transitionend'
		},
		transEndEventName = transEndEventNames[Modernizr.prefixed('transition')],
		onEndTransition = function (el, callback) {
			var onEndCallbackFn = function (ev) {
				if (support.transitions) {
					if (ev.target != this) return;
					this.removeEventListener(transEndEventName, onEndCallbackFn);
				}
				if (callback && typeof callback === 'function') {
					callback.call(this);
				}
			};
			if (support.transitions) {
				el.addEventListener(transEndEventName, onEndCallbackFn);
			} else {
				onEndCallbackFn();
			}
		},
		gridEl = document.getElementById('theGrid'),
		/*sidebarEl = document.getElementById('theSidebar'),*/
		gridItemsContainer = gridEl.querySelector('.grid'),
		contentItemsContainer = gridEl.querySelector('.content'),
		gridItems = gridItemsContainer.querySelectorAll('.grid__item'),
		contentItems = contentItemsContainer.querySelectorAll('.content__item'),
		closeCtrl = contentItemsContainer.querySelector('.close-button'),
		current = -1,
		lockScroll = false,
		xscroll, yscroll,
		isAnimating = false;
		/*menuCtrl = document.getElementById('menu-toggle'),
		menuCloseCtrl = sidebarEl.querySelector('.close-button');*/

	/**
	 * gets the viewport width and height
	 * based on http://responsejs.com/labs/dimensions/
	 */
	function getViewport(axis) {
		var client, inner;
		if (axis === 'x') {
			client = docElem.clientWidth;
			inner = window.innerWidth;
		} else if (axis === 'y') {
			client = docElem.clientHeight;
			inner = window.innerHeight;
		}

		return client < inner ? inner : client;
	}

	function scrollX() {
		return window.pageXOffset || docElem.scrollLeft;
	}

	function scrollY() {
		return window.pageYOffset || docElem.scrollTop;
	}

	function init() {
		initEvents();
	}

	function initEvents() {

		[].slice.call(gridItems).forEach(function (item, pos) {
			// grid item click event
			item.addEventListener('click', function (ev) {
				ev.preventDefault();

				if (isAnimating || current === pos) {
					return false;
				}

				isAnimating = true;
				current = pos;
				classie.add(item, 'grid__item--loading');

				var url = $(item).data('ajaxHref');
				var id = $(item).data('id');
				$.ajax({
					url: url,
					dataType: 'html',
					success: function (data) {
						setTimeout(function () {
							classie.add(item, 'grid__item--animate');
							$('.content__item[data-id="' + id + '"]').prepend(data);
							setTimeout(function () {
								loadContent(item);
							}, 200);
						}, 300);
					}
				});

			});
		});

		closeCtrl.addEventListener('click', function () {
			hideContent();
		});

		// keyboard esc - hide content
		document.addEventListener('keydown', function (ev) {
			if (!isAnimating && current !== -1) {
				var keyCode = ev.keyCode || ev.which;
				if (keyCode === 27) {
					ev.preventDefault();
					hideContent();
				}
			}
		});
	}

	function loadContent(item) {

		var topAssets = 0;
		var endPosition = scrollY() - $('.grid').offset().top + topAssets;

		var dummy = document.createElement('div');
		dummy.className = 'placeholder';
		dummy.style.WebkitTransform = 'translate3d(' + (item.offsetLeft - 5) + 'px, ' + (item.offsetTop - 5) + 'px, 0px) scale3d(' + item.offsetWidth / gridItemsContainer.offsetWidth + ',' + item.offsetHeight / getViewport('y') + ',1)';
		dummy.style.transform = 'translate3d(' + (item.offsetLeft - 5) + 'px, ' + (item.offsetTop - 5) + 'px, 0px) scale3d(' + item.offsetWidth / gridItemsContainer.offsetWidth + ',' + item.offsetHeight / getViewport('y') + ',1)';

		gridItemsContainer.appendChild(dummy);
		classie.add(dummy, 'placeholder--trans-in');
		classie.add(bodyEl, 'project-open');
		$('.grid-wrapper').css("z-index", "2");
		$('.grid-wrapper').css("overflow", "visible");

		setTimeout(function () {
			// expands the placeholder
			dummy.style.WebkitTransform = 'translate3d(-5px, ' + endPosition + 'px, 0px)';
			dummy.style.transform = 'translate3d(-5px, ' + endPosition + 'px, 0px)';
			window.addEventListener('scroll', noscroll);
		}, 25);

		setTimeout(function () {
			$('.subhead').addClass('slide-up');
		}, 200);

		
		vp_init('.player');
		/*as_init('.projects-album-slider');*/
		
		onEndTransition(dummy, function () {
			// add transition class
			var windowRatio = $(window).innerWidth() / $(window).innerHeight();
			var addon = 0;
			if(!$('body').hasClass('section-blog') && windowRatio <= 1 ){ addon = 60; }
			contentItemsContainer.style.top = (endPosition+addon) + 'px';
			
			classie.remove(dummy, 'placeholder--trans-in');
			classie.add(dummy, 'placeholder--trans-out');
			classie.add(contentItemsContainer, 'content--show');
			classie.add(contentItems[current], 'content__item--show');
			classie.add(closeCtrl, 'close-button--show');
			$('body').css('overflow', 'hidden');
			isAnimating = false;			
			$(window).trigger('resize');
		});
	}

	function hideContent() {
		var gridItem = gridItems[current];
		var contentItem = contentItems[current];

		//EMPTY APPENDED DATA AND APPLY CONTACT
		contentItem.innerHTML = '<div id="projects-get-in-touch-block"><h3 class="section-title">Let\'s come up with solutions<br>that will work for you</h3><div class="clearfix text-center center-block"><button class="get-in-touch btn btn-primary">GET IN TOUCH</button></div></div>';

		classie.remove(contentItem, 'content__item--show');
		classie.remove(contentItemsContainer, 'content--show');
		classie.remove(closeCtrl, 'close-button--show');

		$('.subhead').removeClass('slide-up');

		setTimeout(function () {
			var dummy = gridItemsContainer.querySelector('.placeholder');
			dummy.style.WebkitTransform = 'translate3d(' + gridItem.offsetLeft + 'px, ' + gridItem.offsetTop + 'px, 0px) scale3d(' + gridItem.offsetWidth / gridItemsContainer.offsetWidth + ',' + gridItem.offsetHeight / getViewport('y') + ',1)';
			dummy.style.transform = 'translate3d(' + gridItem.offsetLeft + 'px, ' + gridItem.offsetTop + 'px, 0px) scale3d(' + gridItem.offsetWidth / gridItemsContainer.offsetWidth + ',' + gridItem.offsetHeight / getViewport('y') + ',1)';

			onEndTransition(dummy, function () {
				contentItem.parentNode.scrollTop = 0;
				gridItemsContainer.removeChild(dummy);
				classie.remove(gridItem, 'grid__item--loading');
				classie.remove(gridItem, 'grid__item--animate');
				lockScroll = false;
				window.removeEventListener('scroll', noscroll);
				$('body').css('overflow', 'auto');
				classie.remove(bodyEl, 'project-open');
				$('.grid-wrapper').css("z-index", "1");
				$('.grid-wrapper').css("overflow", "hidden");
			});

			current = -1;
		}, 200);
	}

	function noscroll() {
		if (!lockScroll) {
			lockScroll = true;
			xscroll = scrollX();
			yscroll = scrollY();
		}
		window.scrollTo(xscroll, yscroll);
	}

	init();
})();
